module.exports = "<span ng-message=required>*Required</span>";